import { useState } from "react";
import { DialogContent } from "@/components/ui/dialog";

export default function ResizableDialogContent({ children, className = "", defaultW = "80vw", defaultH = "80vh", minW = 500, minH = 400, ...props }) {
  const [customSize, setCustomSize] = useState(null);

  const onMouseDown = (e) => {
    e.preventDefault();
    const startX = e.clientX;
    const startY = e.clientY;
    const el = e.target.closest('[role="dialog"]');
    const startW = el?.offsetWidth || 900;
    const startH = el?.offsetHeight || 700;
    const onMove = (ev) => {
      setCustomSize({
        w: Math.max(minW, Math.min(window.innerWidth * 0.95, startW + (ev.clientX - startX))),
        h: Math.max(minH, Math.min(window.innerHeight * 0.95, startH + (ev.clientY - startY)))
      });
    };
    const onUp = () => { window.removeEventListener('mousemove', onMove); window.removeEventListener('mouseup', onUp); };
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
  };

  const style = customSize
    ? { width: customSize.w, maxWidth: '95vw', height: customSize.h, maxHeight: '95vh' }
    : { width: defaultW, maxWidth: '95vw', height: defaultH, maxHeight: '95vh' };

  return (
    <DialogContent className={`overflow-y-auto ${className}`} style={style} {...props}>
      {children}
      <div className="sticky bottom-0 flex justify-end -mb-4 -mr-2 pt-2 pointer-events-none">
        <div onMouseDown={onMouseDown}
          className="pointer-events-auto w-5 h-5 cursor-nwse-resize flex items-center justify-center opacity-30 hover:opacity-60 transition-opacity"
          data-testid="resize-handle">
          <svg width="10" height="10" viewBox="0 0 10 10"><path d="M9 1L1 9M9 5L5 9M9 9L9 9" stroke="#0D1F3C" strokeWidth="1.5" strokeLinecap="round"/></svg>
        </div>
      </div>
    </DialogContent>
  );
}
